import { Component } from '@angular/core';
import { NavigationService } from '../../../services/navigation.service';
import { TokenPack } from '@mira-avant/mtlibs';
import { AuthService } from '../../../services/auth.service';
import { CognitoService } from '../../../services/cognito.service';
import { GradientBgComponent } from '../../ui/gradient-bg/gradient-bg.component';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { AngularModule } from '../../../modules/angular.module';

@Component({
	selector: 'app-sso-login',
	standalone: true,
	imports: [AngularModule, GradientBgComponent, NzSpinComponent],
	templateUrl: './sso-login.html',
	styleUrl: './sso-login.scss',
})
export class SsoLogin {
	public loading = true;
	private handle: ReturnType<typeof setTimeout> | null = null;

	constructor(
		private authService: AuthService,
		private nav: NavigationService,
		private cognitoService: CognitoService
	) {}

	async ngOnInit() {
		const urlParams = new URLSearchParams(window.location.search);
		const code = urlParams.get('code');

		if (!code) {
			console.error('No code found in query parameters');
			this.loading = false;
			return;
		}

		let tokenPack: TokenPack | undefined;

		try {
			tokenPack = await this.cognitoService.exchangeCleverTokenCodeForTokenPack(code);
		} catch (error) {
			console.error('Error exchanging code for tokenPack:', error);
			this.loading = false;
			return;
		}

		if (!tokenPack) {
			console.error('tokenPack is undefined after exchange');
			this.loading = false;
			return;
		}

		window.history.replaceState({}, document.title, window.location.pathname);

		await this.authService.loginFromTokenPack(tokenPack);

		// Redirect to the my page.
		this.nav.navigate(['/my', 'journey']);

		this.handle = setTimeout(() => {
			this.loading = false;
		}, 10000);
	}

	ngOnDestroy() {
		if (this.handle) {
			clearTimeout(this.handle);
		}
	}
}
